/** @format */

import { configureStore } from "@reduxjs/toolkit";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import {
  PERSIST_STORE_NAME,
  STORE_VERSION,
} from "src/constant/app.constant";
import rootReducer from "./rootReducer";
import RtkQueryService from "src/services/RtkQueryService.js";
import { combineReducers } from "redux";

const middlewares = [RtkQueryService.middleware];

// Configure persist settings
const persistConfig = {
  key: PERSIST_STORE_NAME,
  keyPrefix: "",
  storage,
  whitelist: ["mode", "auth", "locale", "setting", "role"],
};

// Create the store with initial settings
const store = configureStore({
  reducer: persistReducer(persistConfig, rootReducer()),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(middlewares),
  devTools: process.env.NODE_ENV === "development",
});

store.asyncReducers = {};
store.tableReducers = {};

export const persistor = persistStore(store);

function checkAndUpdateStoreVersion() {
  const currentVersion = localStorage.getItem("store_version");
  if (currentVersion !== STORE_VERSION) {
    persistor.purge().then(() => {
      localStorage.setItem("store_version", STORE_VERSION);
    });
  }
}

checkAndUpdateStoreVersion();

export function injectReducer(key, reducer) {
  if (store.asyncReducers) {
    if (store.asyncReducers[key]) {
      return false;
    }
    store.asyncReducers[key] = reducer;
    store.replaceReducer(
      persistReducer(persistConfig, rootReducer(store.asyncReducers))
    );
  }
  persistor.persist();
  return store;
}

const tableName = "table";

export function injectTableReducer(key, reducer) {
  if (store.tableReducers && store.asyncReducers) {
    if (store.tableReducers[key]) {
      return false;
    }
    store.tableReducers[key] = reducer;
    store.asyncReducers[tableName] = combineReducers(store.tableReducers);
    store.replaceReducer(
      persistReducer(persistConfig, rootReducer(store.asyncReducers))
    );
  }
  persistor.persist();
  return store;
}

export const AppDispatch = store.dispatch;

export default store;
